var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routerView)?_c('div',[_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[_c('keep-alive',{attrs:{"include":_vm.cachedRoutes,"max":_vm.keepAliveMaxNum}},[_c('router-view',{key:_vm.key})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }